import React, { useEffect } from 'react';

export const BORDER = 'border-[#cfcac2]';

/** Real error text of a failed API call: the backend puts it in `results` (and a generic text in `message`) */
export const errMsg = (res, fallback) => {
  const d = res?.data;
  return (typeof d?.results === 'string' && d.results) || d?.message || fallback;
};

export const fmtDate = (d) => (d ? new Date(d).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) : '—');
export const fmtDay = (d) => (d ? new Date(d).toLocaleDateString([], { dateStyle: 'medium' }) : '—');

const STATUS_STYLES = {
  Draft: 'bg-gray-100 text-gray-700 ring-gray-300',
  'Pending Empivo Review': 'bg-amber-50 text-amber-800 ring-amber-300',
  'Information Requested': 'bg-orange-50 text-orange-800 ring-orange-300',
  Approved: 'bg-blue-50 text-blue-800 ring-blue-300',
  Rejected: 'bg-red-50 text-red-800 ring-red-300',
  'Submitted to Everee': 'bg-indigo-50 text-indigo-800 ring-indigo-300',
  Active: 'bg-green-50 text-green-800 ring-green-300',
};
const STATUS_LABEL = { 'Pending Empivo Review': 'Payroll Setup – Empivo Review' };

export const StatusBadge = ({ status, className = '' }) => (
  <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${STATUS_STYLES[status] || STATUS_STYLES.Draft} ${className}`}>
    {STATUS_LABEL[status] || status}
  </span>
);

export const Flag = ({ ok, yes = 'Yes', no = 'No' }) => (
  <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${ok ? 'text-green-700' : 'text-red-600'}`}>
    <span className={`flex h-4 w-4 items-center justify-center rounded-full text-[10px] text-white ${ok ? 'bg-green-600' : 'bg-red-500'}`}>{ok ? '✓' : '✕'}</span>
    {ok ? yes : no}
  </span>
);

/** Card with the tan title strip used across the Word-style forms */
export const Card = ({ title, action, children, className = '' }) => (
  <section className={`border ${BORDER} bg-white ${className}`}>
    <header className="flex items-center justify-between bg-[#e6e3de] px-4 py-2">
      <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-gray-700">{title}</h3>
      {action}
    </header>
    <div className="p-4">{children}</div>
  </section>
);

export const Item = ({ label, children }) => (
  <div className="min-w-0">
    <dt className="text-[11px] font-semibold uppercase tracking-wider text-gray-500">{label}</dt>
    <dd className="mt-0.5 truncate text-sm font-medium text-gray-900">{children || children === 0 ? children : '—'}</dd>
  </div>
);

export const Btn = ({ variant = 'secondary', className = '', ...props }) => {
  const v = {
    primary: 'bg-blue-700 text-white hover:bg-blue-800',
    success: 'bg-green-700 text-white hover:bg-green-800',
    danger: 'bg-red-600 text-white hover:bg-red-700',
    secondary: 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50',
  }[variant];
  return (
    <button
      type="button"
      className={`rounded px-4 py-2 text-sm font-semibold shadow-sm transition focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${v} ${className}`}
      {...props}
    />
  );
};

export const Modal = ({ title, onClose, children, footer, wide }) => {
  useEffect(() => {
    const h = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div role="dialog" aria-modal="true" aria-label={title} className={`flex max-h-[90vh] w-full flex-col rounded-lg bg-white shadow-2xl ${wide ? 'max-w-3xl' : 'max-w-lg'}`}>
        <div className="flex items-center justify-between border-b border-gray-200 px-5 py-3">
          <h3 className="text-base font-bold text-gray-900">{title}</h3>
          <button type="button" onClick={onClose} aria-label="Close" className="text-xl leading-none text-gray-400 hover:text-gray-700">×</button>
        </div>
        <div className="overflow-y-auto px-5 py-4">{children}</div>
        {footer && <div className="flex justify-end gap-2 border-t border-gray-200 bg-gray-50 px-5 py-3">{footer}</div>}
      </div>
    </div>
  );
};

export const textareaCls =
  'w-full rounded border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600';
export const inputCls = textareaCls;





// import React, { useEffect } from 'react';

// export const BORDER = 'border-[#cfcac2]';

// export const fmtDate = (d) => (d ? new Date(d).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) : '—');
// export const fmtDay = (d) => (d ? new Date(d).toLocaleDateString([], { dateStyle: 'medium' }) : '—');

// const STATUS_STYLES = {
//   Draft: 'bg-gray-100 text-gray-700 ring-gray-300',
//   'Pending Empivo Review': 'bg-amber-50 text-amber-800 ring-amber-300',
//   'Information Requested': 'bg-orange-50 text-orange-800 ring-orange-300',
//   Approved: 'bg-blue-50 text-blue-800 ring-blue-300',
//   Rejected: 'bg-red-50 text-red-800 ring-red-300',
//   'Submitted to Everee': 'bg-indigo-50 text-indigo-800 ring-indigo-300',
//   Active: 'bg-green-50 text-green-800 ring-green-300',
// };
// const STATUS_LABEL = { 'Pending Empivo Review': 'Payroll Setup – Empivo Review' };

// export const StatusBadge = ({ status, className = '' }) => (
//   <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${STATUS_STYLES[status] || STATUS_STYLES.Draft} ${className}`}>
//     {STATUS_LABEL[status] || status}
//   </span>
// );

// export const Flag = ({ ok, yes = 'Yes', no = 'No' }) => (
//   <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${ok ? 'text-green-700' : 'text-red-600'}`}>
//     <span className={`flex h-4 w-4 items-center justify-center rounded-full text-[10px] text-white ${ok ? 'bg-green-600' : 'bg-red-500'}`}>{ok ? '✓' : '✕'}</span>
//     {ok ? yes : no}
//   </span>
// );

// /** Card with the tan title strip used across the Word-style forms */
// export const Card = ({ title, action, children, className = '' }) => (
//   <section className={`border ${BORDER} bg-white ${className}`}>
//     <header className="flex items-center justify-between bg-[#e6e3de] px-4 py-2">
//       <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-gray-700">{title}</h3>
//       {action}
//     </header>
//     <div className="p-4">{children}</div>
//   </section>
// );

// export const Item = ({ label, children }) => (
//   <div className="min-w-0">
//     <dt className="text-[11px] font-semibold uppercase tracking-wider text-gray-500">{label}</dt>
//     <dd className="mt-0.5 truncate text-sm font-medium text-gray-900">{children || children === 0 ? children : '—'}</dd>
//   </div>
// );

// export const Btn = ({ variant = 'secondary', className = '', ...props }) => {
//   const v = {
//     primary: 'bg-blue-700 text-white hover:bg-blue-800',
//     success: 'bg-green-700 text-white hover:bg-green-800',
//     danger: 'bg-red-600 text-white hover:bg-red-700',
//     secondary: 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50',
//   }[variant];
//   return (
//     <button
//       type="button"
//       className={`rounded px-4 py-2 text-sm font-semibold shadow-sm transition focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${v} ${className}`}
//       {...props}
//     />
//   );
// };

// export const Modal = ({ title, onClose, children, footer, wide }) => {
//   useEffect(() => {
//     const h = (e) => e.key === 'Escape' && onClose();
//     window.addEventListener('keydown', h);
//     return () => window.removeEventListener('keydown', h);
//   }, [onClose]);

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
//       <div role="dialog" aria-modal="true" aria-label={title} className={`flex max-h-[90vh] w-full flex-col rounded-lg bg-white shadow-2xl ${wide ? 'max-w-3xl' : 'max-w-lg'}`}>
//         <div className="flex items-center justify-between border-b border-gray-200 px-5 py-3">
//           <h3 className="text-base font-bold text-gray-900">{title}</h3>
//           <button type="button" onClick={onClose} aria-label="Close" className="text-xl leading-none text-gray-400 hover:text-gray-700">×</button>
//         </div>
//         <div className="overflow-y-auto px-5 py-4">{children}</div>
//         {footer && <div className="flex justify-end gap-2 border-t border-gray-200 bg-gray-50 px-5 py-3">{footer}</div>}
//       </div>
//     </div>
//   );
// };

// export const textareaCls =
//   'w-full rounded border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600';
// export const inputCls = textareaCls;
